import { render, staticRenderFns } from "./FoshanArea.vue?vue&type=template&id=76ab3552&"
import script from "./FoshanArea.vue?vue&type=script&lang=js&"
export * from "./FoshanArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports